import type { CSSProperties } from 'react';

/** Input/select inline style for the create forms' three field states. Token
 *  colours, so it follows the theme; inline, so the dashboards button/input
 *  reset cannot beat it. */
export function fieldStyle(
  state: 'error' | 'suggested' | undefined,
  extra?: CSSProperties,
): CSSProperties {
  return {
    width: '100%',
    height: 32,
    padding: '0 10px',
    borderRadius: 8,
    fontSize: 12.5,
    background: state === 'suggested' ? 'var(--nb-primary-soft)' : 'var(--nb-bg)',
    color: 'var(--nb-ink)',
    border: `1px solid ${
      state === 'error'
        ? 'var(--nb-risk)'
        : state === 'suggested'
          ? 'var(--nb-primary)'
          : 'var(--nb-border-2)'
    }`,
    ...extra,
  };
}
